import { useNavigate } from "react-router-dom";
import { AccountResult } from "../../layout/account/AccountResult";
import { useTranslation } from "react-i18next";

export function SignUpSuccess() {
  const { t } = useTranslation("account");
  const navigate = useNavigate();

  return (
    <AccountResult
      title={t("signUpSuccess.title")}
      description={t("signUpSuccess.description")}
      buttonText={t("signUpSuccess.button")}
      buttonAction={() => navigate(`/login`)}
    />
  );
}
